// glossary of 'pages' that are translated
// each page has english, spanish, and tagalog urls
// when adding a page, make sure that all the translation urls for the new page are live before updating this file
export default {
  faq: {
    en: '/coronavirus-veteran-frequently-asked-questions',
    es: '/coronavirus-veteran-frequently-asked-questions-esp',
    tl: '/coronavirus-veteran-frequently-asked-questions-tag',
  },
  vaccine: {
    en: '/health-care/covid-19-vaccine',
    es: '/health-care/covid-19-vaccine-esp',
    tl: '/health-care/covid-19-vaccine-tag',
  },
  booster: {
    en: '/health-care/covid-19-vaccine/booster-shots-and-additional-doses',
    es:
      '/health-care/covid-19-vaccine-esp/booster-shots-and-additional-doses-esp',
    tl:
      '/health-care/covid-19-vaccine-tag/booster-shots-and-additional-doses-tag',
  },
  vaccineRecord: {
    en: '/health-care/covid-19-vaccine/vaccine-record',
    es: '/health-care/covid-19-vaccine-esp/vaccine-record-esp',
    tl: '/health-care/covid-19-vaccine-tag/vaccine-record-tag',
  },
  about: {
    en: '/health-care/covid-19-vaccine/about-covid-19-vaccine',
    es: '/health-care/covid-19-vaccine-esp/about-covid-19-vaccine-esp',
    tl: '/health-care/covid-19-vaccine-tag/about-covid-19-vaccine-tag',
  },
  pact: {
    en: '/resources/the-pact-act-and-your-va-benefits',
    es: '/resources/the-pact-act-and-your-va-benefits-esp',
    tl: '/resources/the-pact-act-and-your-va-benefits-tag',
  },
  disability: {
    en: '/disability/eligibility/',
    es: '/disability/eligibility-esp/',
  },
  fileDisability: {
    en: '/disability/how-to-file-claim/',
    es: '/disability/how-to-file-claim-esp/',
  },
  afterFileDisability: {
    en: '/disability/after-you-file-claim/',
    es: '/disability/after-you-file-claim-esp/',
  },
  healthCareEligibility: {
    en: '/health-care/eligibility/',
    es: '/health-care/eligibility-esp/',
  },
  healthCareHowToApply: {
    en: '/health-care/how-to-apply/',
    es: '/health-care/how-to-apply-esp/',
  },
  healthCareAfterAppy: {
    en: '/health-care/after-you-apply/',
    es: '/health-care/after-you-apply-esp/',
  },
  compAssistanceForFamily: {
    en:
      '/family-and-caregiver-benefits/health-and-disability/comprehensive-assistance-for-family-caregivers/',
    es:
      '/family-and-caregiver-benefits/health-and-disability/comprehensive-assistance-for-family-caregivers-esp/',
  },
  decisionReviewsSupplementalClaim: {
    en: '/decision-reviews/supplemental-claim/',
    es: '/decision-reviews/supplemental-claim-esp/',
  },
  reportHarassment: {
    en: '/report-harassment/',
    es: '/report-harassment-esp/',
  },
  accessibility: {
    en: '/accessibility-at-va/',
    es: '/accessibility-at-va-esp/',
  },
  education: {
    en: '/education/eligibility/',
    es: '/education/eligibility-esp/',
  },
  dependencyIndemnity: {
    en: '/disability/dependency-indemnity-compensation/',
    es: '/disability/dependency-indemnity-compensation-esp/',
  },
  signingIn: {
    en: '/resources/signing-in-to-vagov/',
    es: '/resources/signing-in-to-vagov-esp/',
  },
  createSignIn: {
    en: '/resources/what-to-bring-to-create-your-online-sign-in-account/',
    es: '/resources/what-to-bring-to-create-your-online-sign-in-account-esp/',
  },
  survivorDependencyIndemnity: {
    en:
      '/family-and-caregiver-benefits/survivor-compensation/dependency-indemnity-compensation/',
    es:
      '/family-and-caregiver-benefits/survivor-compensation/dependency-indemnity-compensation-esp/',
  },
  disasterHelp: {
    en: '/resources/disaster-help/',
    es: '/resources/disaster-help-esp/',
  },
  creatingAnAccount: {
    en: '/resources/creating-an-account-for-vagov/',
    es: '/resources/creating-an-account-for-vagov-esp/',
  },
  verifyingYourIdentiy: {
    en: '/resources/verifying-your-identity-on-vagov/',
    es: '/resources/verifying-your-identity-on-vagov-esp/',
  },
  dentalCare: {
    en: '/health-care/about-va-health-benefits/dental-care/',
    es: '/health-care/about-va-health-benefits/dental-care-esp/',
  },
  survivorsPension: {
    en:
      '/family-and-caregiver-benefits/survivor-compensation/survivors-pension/',
    es:
      '/family-and-caregiver-benefits/survivor-compensation/survivors-pension-esp/',
  },
  vocationalRehabilitationHowToApply: {
    en: '/careers-employment/vocational-rehabilitation/how-to-apply/',
    es: '/careers-employment/vocational-rehabilitation/how-to-apply-esp/',
  },
  decisionReviewsBoardAppeal: {
    en: '/decision-reviews/board-appeal/',
    es: '/decision-reviews/board-appeal-esp/',
  },
  vocationalRehabilitation: {
    en: '/careers-employment/vocational-rehabilitation/eligibility/',
    es: '/careers-employment/vocational-rehabilitation/eligibility-esp/',
  },
  afterYourReview: {
    en: '/decision-reviews/after-you-request-review/',
    es: '/decision-reviews/after-you-request-review-esp/',
  },
  howToRequestCOE: {
    en: '/housing-assistance/home-loans/how-to-request-coe/',
    es: '/housing-assistance/home-loans/how-to-request-coe-esp/',
  },
};
